// extracted by mini-css-extract-plugin
module.exports = {"container":"stream__container___24sHD","stream-component":"stream__stream-component___3HcDq","is-fullscreen-active":"stream__is-fullscreen-active___2AWEn"};